import { FC } from 'react';
import { LozingsvormBase } from '../lozingsvorm-base';

interface Properties {
  teeltwijze: number;
}

export const LozingsvormV1: FC<Properties> = ({ teeltwijze }) => <LozingsvormBase teeltwijze={teeltwijze} values={[0, 1, 2, 3, 4]} />;
